import React from "react";
import PropTypes from "prop-types";
import queryToUrl from "../../helpers/queryToUrl";
import SrpContainer from "../../containers/SrpContainer";
import { subscribe } from "venuescanner-js/react/helpers";

const LoadMoreButton = ({ currentPage, onClick, query }) => (
  <a
    href={queryToUrl({ ...query, page: currentPage + 1 })}
    className="srp-load-more-button"
    data-page={currentPage + 1}
    data-ga={`srp_next_page ${currentPage}`}
    onClick={(e) => {
      e.preventDefault();
      onClick();
    }}
  >
    Load more
  </a>
);

LoadMoreButton.propTypes = {
  currentPage: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  query: PropTypes.object.isRequired,
};

export default subscribe({ SrpContainer })(({ srpContainer }) => (
  <LoadMoreButton
    currentPage={srpContainer.state.pageInViewport}
    query={srpContainer.state.query}
    onClick={() => srpContainer.loadPage(srpContainer.state.pageInViewport + 1)}
  />
));
